import React, { useState } from 'react';
import {
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import { MdOutlineRefresh } from 'react-icons/md';
import moment from 'moment';
import Card from 'components/card/Card';

const CheckerDetailsTable = (props) => {
  const checkerDetailsList = props.checkerDetails;

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Flex
      height='100%'
      direction='column'>
      <Card
        mt={4}
        direction='column'
        bgColor='gray.200'
        w='100%'
        minHeight='12rem'
        maxHeight='42rem'
        px='0px'
        overflowX='scroll'>
        <Flex overflow='visible'>
          <Table
            variant='simple'
            color='gray.500'
            mb='24px'>
            <Thead>
              <Tr>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Checker Name
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Approval Status
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Time of Approval
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Comments
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {checkerDetailsList?.map((obj, index) => {
                return (
                  // <Link to={{ pathname: '/permission-group', state: obj.id }}>
                  <Tr key={obj.id}>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {obj.checker_name}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          fontSize='sm'
                          fontWeight='700'
                          color={
                            obj.approval_status === 'ACCEPT'
                              ? 'green'
                              : obj.approval_status === 'REJECT'
                              ? 'red'
                              : ''
                          }>
                          {obj.approval_status}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {moment(obj.approved_at).format('DD MMM YY, HH:mm')}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {obj.comments}
                        </Text>
                      </Flex>
                    </Td>
                  </Tr>
                  // </Link>
                );
              })}
            </Tbody>
          </Table>
        </Flex>
      </Card>
    </Flex>
  );
};

export default CheckerDetailsTable;
